import { useLocalStore } from 'mobx-react-lite';

import {
  IcArticleIcon,
  IcDocumentStrokeIcon,
  IcImgIcon,
  IcLinkIcon,
  IcMicOnIcon,
  IcMusicIcon,
} from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';

import Entities from 'STORE';

export default ({ groupId, actions }) => {
  const { t } = useTranslation();
  const presenter = useLocalStore(() => ({
    get items() {
      const group = Entities.GroupsStore.getGroupById(groupId);
      if (!group) {
        return [];
      }
      const sharedData = group.sharedData;

      return [
        {
          key: 'media',
          Icon: IcImgIcon,
          title: t('common_media'),
          onClick: actions.openMedia,
          count: sharedData.media.count,
          isVisible: sharedData.media.count > 0 && !group.isSavedMessages,
        },
        {
          key: 'files',
          Icon: IcDocumentStrokeIcon,
          title: t('common_files'),
          onClick: actions.openFiles,
          count: sharedData.files.count,
          isVisible: sharedData.files.count > 0,
        },
        {
          key: 'links',
          Icon: IcLinkIcon,
          title: t('common_links'),
          onClick: actions.openLinks,
          count: sharedData.links.count,
          isVisible: sharedData.links.count > 0,
        },
        {
          key: 'audio',
          Icon: IcMusicIcon,
          title: t('common_audio_files'),
          onClick: actions.openAudioFiles,
          count: sharedData.audio.count,
          isVisible: sharedData.audio.count > 0,
        },
        {
          key: 'voices',
          Icon: IcMicOnIcon,
          title: t('common_voice'),
          onClick: actions.openVoices,
          count: sharedData.voices.count,
          isVisible: sharedData.voices.count > 0,
        },
        {
          key: 'articles',
          Icon: IcArticleIcon,
          title: t('common_articles'),
          onClick: actions.openArticles,
          count: sharedData.articles.count,
          isVisible: sharedData.articles.count > 0,
        },
      ].filter((item) => item.isVisible);
    },
  }));

  return presenter;
};
